import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "searchInput", "filterButton", "resultCount"]

  connect() {
    this.currentFilter = "all"
    this.currentSearch = ""

    // Set up search input listener
    const searchInput = document.getElementById("distillery-search")
    if (searchInput) {
      searchInput.addEventListener("input", (e) => this.search(e))
    }

    // Set up filter button listeners
    const filterButtons = document.querySelectorAll("[data-filter]")
    filterButtons.forEach(btn => {
      btn.addEventListener("click", (e) => this.filter(e))
    })
  }

  search(event) {
    this.currentSearch = event.target.value.toLowerCase()
    this.applyFilters()
  }

  filter(event) {
    const filterType = event.currentTarget.dataset.filter
    this.currentFilter = filterType

    // Update button states
    const filterButtons = document.querySelectorAll("[data-filter]")
    filterButtons.forEach(btn => {
      if (btn.dataset.filter === filterType) {
        btn.classList.remove("border-border", "bg-muted", "text-foreground")
        btn.classList.add("border-primary", "bg-primary/10", "text-primary")
      } else {
        btn.classList.remove("border-primary", "bg-primary/10", "text-primary")
        btn.classList.add("border-border", "bg-muted", "text-foreground")
      }
    })

    this.applyFilters()
  }

  applyFilters() {
    const cards = document.querySelectorAll("#distillery-results .grid > div")
    let visibleCount = 0

    cards.forEach(card => {
      const text = card.textContent.toLowerCase()
      const matchesSearch = text.includes(this.currentSearch)

      let matchesFilter = true
      if (this.currentFilter !== "all") {
        // Check for producer type badge in the card
        const badge = card.querySelector('[data-producer-type]')
        if (badge) {
          const producerType = badge.dataset.producerType.toLowerCase()
          matchesFilter = producerType === this.currentFilter
        } else {
          matchesFilter = false
        }
      }

      if (matchesSearch && matchesFilter) {
        card.style.display = "block"
        visibleCount++
      } else {
        card.style.display = "none"
      }
    })

    // Update result count
    const resultText = document.querySelector("#distillery-results .text-sm")
    if (resultText) {
      const plural = visibleCount === 1 ? "distillery" : "distilleries"
      resultText.textContent = `${visibleCount} ${plural} found`
    }

    // Update heading
    const heading = document.querySelector("#distillery-results h2")
    if (heading) {
      if (this.currentSearch || this.currentFilter !== "all") {
        heading.textContent = "Search Results"
      } else {
        heading.textContent = "All Distilleries"
      }
    }
  }
}
